export const TOGGLE_VIEW = {
  DISCOVERY_REFERRAL_TOGGLE: 'DISCOVERY_REFERRAL_TOGGLE',
};
